import { render, staticRenderFns } from "./secondBook.vue?vue&type=template&id=601d071a&scoped=true&"
import script from "./secondBook.vue?vue&type=script&lang=js&"
export * from "./secondBook.vue?vue&type=script&lang=js&"
import style0 from "./secondBook.vue?vue&type=style&index=0&id=601d071a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d071a",
  null
  
)

export default component.exports